module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn btn-xs p-0",
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [(_vm.status) ? _c('img', {
    attrs: {
      "src": _vm.imgOn
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgOff
    }
  }), _vm._v(" "), (_vm.leftLabel !== '' && _vm.rightLabel !== '') ? [_c('span', {
    class: {
      'switch': true, 'past': _vm.status
    }
  }, [_vm._v(_vm._s(_vm.leftLabel))]), _vm._v("/"), _c('span', {
    class: {
      'switch': true, 'past': !_vm.status
    }
  }, [_vm._v(_vm._s(_vm.rightLabel))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1af0e9be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/SwitchButton.vue
// module id = 752
// module chunks = 3